import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { setPageSeo } from "../lib/seo";

const SITEMAP_LINKS = [
  {
    category: "Main",
    links: [
      { name: "Home", path: "/" },
      { name: "What We Build", path: "/#services" },
      // { name: "Products", path: "/#products" },
      { name: "Pricing", path: "/#pricing" },
      { name: "Process", path: "/#process" },
      { name: "Tech Stack", path: "/#tech-stack" },
      { name: "About", path: "/about" },
      { name: "FAQ", path: "/#faq" },
      { name: "Contact", path: "/contact" },
    ],
  },
  {
    category: "Legal & Support",
    links: [
      { name: "Privacy Policy", path: "/privacy" },
      { name: "Terms & Conditions", path: "/terms" },
      { name: "Refund & Cancellation", path: "/refund" },
      { name: "Shipping & Delivery", path: "/shipping" },
      { name: "Book Discovery Call", path: "/book-call" },
    ],
  },
];

export default function Sitemap() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageSeo({
      title: "Sitemap — Devzcorner",
      description: "Browse all primary, legal, and support pages available on Devzcorner.",
      path: "/sitemap",
    });
  }, []);

  return (
    <main className="relative bg-ink-0 text-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-24 px-6 md:px-10 max-w-4xl mx-auto w-full">
        <h1 className="font-display text-4xl md:text-5xl mb-12">Sitemap</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {SITEMAP_LINKS.map((section) => (
            <div key={section.category}>
              <h2 className="text-xl font-display text-white mb-6 border-b border-white/10 pb-4">
                {section.category}
              </h2>
              <ul className="space-y-4">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.path}
                      className="text-zinc-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
}
